import streamTmp from './stream-tmp/config'
import VideoDescCard from './video-desc-card'
import ProductInfoCard from './product-info-card'
import VideoGenCard from './video-gen-card'

const templateMap = {
  ...streamTmp,
  video_desc_card: VideoDescCard,
  product_info_card: ProductInfoCard,
  video_gen_card: VideoGenCard
}

export default templateMap
